import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { IconWarningOutline } from '@icons/IconWarningOutline'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { Badge } from '@/components/shadcn/badge'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense } from 'react'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'

export function DatabricksStatusSection() {
  return (
    <SectionContainer title="Workspace status">
      <QueryErrorBoundary errorMessage="Failed to check workspace status">
        <Suspense fallback={<DatabricksStatusSectionLoading />}>
          <DatabricksStatusSectionContent />
        </Suspense>
      </QueryErrorBoundary>
    </SectionContainer>
  )
}

function DatabricksStatusSectionContent() {
  const currentWorkspace = useCurrentWorkspace()
  const { workspaceId } = currentWorkspace
  const { getDatabricksApiGetDatabricksWorkspaceStatus } = useRestClient()
  const { data: workspace } = getDatabricksApiGetDatabricksWorkspaceStatus.useSuspenseQuery({ query: { workspaceId } })
  return workspace?.message ? (
    <div className="flex gap-5 rounded-lg border-l-8 border-yellow-400 bg-yellow-50 p-4 text-yellow-700">
      <IconWarningOutline className="size-7 shrink-0" />
      <div className="flex flex-col gap-2">
        <div className="text whitespace-pre-wrap font-light italic">{workspace?.message}</div>
      </div>
    </div>
  ) : (
    <div>
      <Badge variant="success">Ready</Badge>
    </div>
  )
}

function DatabricksStatusSectionLoading() {
  return <LoadingComponent text="Checking workspace status" />
}
